export enum deleteVerificationModalActions {
  Delete,
  Cancel,
}
